module.exports = __webpack_public_path__ + "img/product-preview-3.133c6c9.png";